import { render, staticRenderFns } from "./FormMadiumProtocol.vue?vue&type=template&id=0e98d819"
import script from "./FormMadiumProtocol.vue?vue&type=script&lang=js"
export * from "./FormMadiumProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports